import {
  TRAINING_AUTH_ACTION,
  TRAINING_AUTH_KEY
} from 'modules/training/modules/app-auth/constants'
import updateTrainingAuthAction from 'modules/training/modules/app-auth/actions/update'

function updatePasswordTrainingAuthAction (value) {
  return updateTrainingAuthAction({
    type: TRAINING_AUTH_ACTION.UPDATE_PASSWORD,
    payload: {
      key: TRAINING_AUTH_KEY.PASSWORD,
      value
    }
  })
}

export default updatePasswordTrainingAuthAction
